export default "__VITE_ASSET__78163e2a__"